import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import '../modal.scss';
import More from '../More';
import { useTranslation } from 'react-i18next';
import { TitleType } from '@/utils/contants';
// import Type from './Type';
export interface ITitleModalProps {
  title: string;
  hiddenModal: () => void;
  titleInfo?: TitlePerson | TitleEnterprise;
  submitAction: (params) => void;
}

const Title: React.FC<ITitleModalProps> = ({
  hiddenModal,
  title,
  titleInfo,
  submitAction,
}) => {
  const [form] = Form.useForm();
  const titleType = Form.useWatch('type', form);
  const { t, i18n } = useTranslation();
  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        submitAction(values);
        hiddenModal();
      })
      .catch((info) => {
        // console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open
      wrapClassName="modal-wrapper"
      onCancel={hiddenModal}
      footer={
        <>
          <button className="cancel" onClick={hiddenModal}>
            {t('取消')}
          </button>
          <button className="done" onClick={handleSubmit}>
            {t('提交')}
          </button>
        </>
      }
      width="50.667rem"
      title={t(title)}
      centered
      maskClosable={false}
    >
      <Form
        form={form}
        colon={false}
        labelCol={{ span: i18n.language === 'en' ? 8 : 5 }}
        wrapperCol={{ span: i18n.language === 'en' ? 17 : 19 }}
        style={{ width: '90%' }}
        labelAlign="left"
        initialValues={titleInfo || { type: 1 }}
      >
        {titleInfo?.type && (
          <Form.Item
            name="type"
            initialValue={titleInfo.type}
            style={{ display: 'none' }}
          >
            <div></div>
          </Form.Item>
        )}
        <Form.Item name="id" style={{ display: 'none' }}>
          <div></div>
        </Form.Item>
        {!titleInfo && (
          <Form.Item name="type" label={t('抬头类型')}>
            <Select
              options={[
                { value: 1, label: `${t('企业或单位')}` },
                { value: 2, label: `${t('个人')}` },
                { value: 3, label: `${t('事业单位/军队/政府机构')}` },
              ]}
            />
          </Form.Item>
        )}

        <Form.Item
          name="title"
          label={t('抬头名称')}
          rules={[
            { required: true, message: `${t('抬头名称')} ${t('不能为空')}` },
          ]}
        >
          <Input placeholder={t('必填')} maxLength={255} />
        </Form.Item>
        {([TitleType.Company, TitleType.Government].includes(titleType) ||
          (titleInfo as TitleEnterprise)?.taxpayer_identification_number) && (
          <>
            <Form.Item
              name="taxpayer_identification_number"
              label={
                <span style={{ textWrap: 'wrap', lineHeight: '18px' }}>
                  {t('纳税人识别号')}
                </span>
              }
              rules={[
                () => ({
                  validator(_, value = '') {
                    if (titleType !== TitleType.Company && !value) {
                      return Promise.resolve();
                    }

                    if (
                      (titleType === TitleType.Company && value.length) === 0
                    ) {
                      return Promise.reject(
                        new Error(`${t('纳税人识别号')} ${t('不能为空')}`)
                      );
                    }
                    const validateSpace = /\s/.test(value);
                    const validateNumberAndChar = /^[A-Z\d]+$/.test(value);
                    const lengthArr = [8, 9, 10, 11, 12, 15, 16, 17, 18, 20];
                    const validateLength = lengthArr.includes(value.length);
                    if (
                      validateSpace ||
                      !validateNumberAndChar ||
                      !validateLength
                    ) {
                      return Promise.reject(
                        new Error(
                          t(
                            '请校验纳税人识别号长度是否正确，若包含字母须大写，且不得含有空格'
                          )
                        )
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                placeholder={
                  titleType === TitleType.Company ? t('必填') : t('选填')
                }
                maxLength={64}
              />
            </Form.Item>
            <More pageType="personal" />
          </>
        )}
      </Form>
    </Modal>
  );
};

export default Title;
